import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { useEmailOptions } from 'shared/components/dashboard-mail-editor/hooks/use-email-options';
import { DashboardMailEditorProps, ExtendedState } from 'shared/components/dashboard-mail-editor/types/common';
import { isWithRecipient } from 'shared/components/dashboard-mail-editor/utils/is-with-recipients';
export const useSetDefaultEmailOptions = (data, onChange, options) => {
  const $ = _c(15);
  const [isOptionsApplied, setIsOptionsApplied] = useState(false);
  const {
    data: emailOptions
  } = useEmailOptions();
  let t0;
  if ($[0] !== data || $[1] !== emailOptions || $[2] !== isOptionsApplied || $[3] !== onChange || $[4] !== options?.withRecipient) {
    t0 = () => {
      if (isOptionsApplied || !emailOptions || !data) {
        return;
      }
      if (options?.withRecipient && isWithRecipient(options?.withRecipient, data)) {
        onChange({
          ...data,
          fromEmail: data.fromEmail || emailOptions.senderEmailAddress,
          fromName: data.fromName || emailOptions.senderName,
          recipient: data.recipient || emailOptions.testEmailAddress
        });
      } else {
        onChange({
          ...data,
          fromEmail: data.fromEmail || emailOptions.senderEmailAddress,
          fromName: data.fromName || emailOptions.senderName
        });
      }
      setIsOptionsApplied(true);
    };
    $[0] = data;
    $[1] = emailOptions;
    $[2] = isOptionsApplied;
    $[3] = onChange;
    $[4] = options?.withRecipient;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const t1 = options?.withRecipient;
  let t2;
  if ($[6] !== data || $[7] !== emailOptions || $[8] !== isOptionsApplied || $[9] !== onChange || $[10] !== options || $[11] !== t1) {
    t2 = [isOptionsApplied, onChange, options, data, t1, emailOptions];
    $[6] = data;
    $[7] = emailOptions;
    $[8] = isOptionsApplied;
    $[9] = onChange;
    $[10] = options;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  useEffect(t0, t2);
  let t3;
  if ($[13] !== isOptionsApplied) {
    t3 = {
      isOptionsApplied
    };
    $[13] = isOptionsApplied;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};